import { AppGrid } from "@/components/AppGrid/AppGrid";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { ContactRecord, contactModel } from "@/models/contact";
import { getDefaultContactDirectoryEntity } from "@/models/contactDirectory";
import { userIsCreatorConstraint } from "@/orm/model";
import { PartialEntityRecord } from "@/orm/types";
import { Box } from "@mantine/core";
import { colDefs, defaultColDef } from "../colDefs";

export const Main = () => {
  const contactDirectoryAcitveRecord = getDefaultContactDirectoryEntity();
  const queryAtom =
    contactDirectoryAcitveRecord.getObserveManyBelongingsAtom<ContactRecord>(
      contactModel,
      "belongsToContactDirectoryIds",
      { constraints: [userIsCreatorConstraint()] },
    );

  const update = (id: string, data: PartialEntityRecord<ContactRecord>) => {
    const record = contactModel.createEntityInstance({ id });
    return record.update(data);
  };

  const { isPlanInactive } = useIsPlanInactive();

  return (
    <Box
      bg="gray"
      style={{
        width: "100%",
        height: "100%",
        justifySelf: "stretch",
        alignSelf: "stretch",
        flex: 1,
      }}
    >
      <AppGrid
        id={"contact"}
        queryAtom={queryAtom}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        onCellValueChanged={(event) => {
          update(event.data.id, event.data);
        }}
        isReadOnly={isPlanInactive}
      />
    </Box>
  );
};
